'use client';

import { useGetGameFromRouteParams } from '@/hooks/useGetGameFromParams.hook';
import { PickemRewardCard } from '../PickemRewardCard';
import { PickemsRewardsMinimumParticipantsNote } from '../PickemsRewardsMinimumParticipantsNote';
import { getRewardsForGame } from '../rewards';

export const PickemsLeaderboardRewards = ({
  rewardsNotice,
}: {
  rewardsNotice: string;
}) => {
  const { game } = useGetGameFromRouteParams();
  const rewards = getRewardsForGame(game);

  return (
    <div className="rounded-lg bg-dark-gray p-6">
      <div className="flex flex-col gap-3">
        <h2 className="font-semibold text-white text-xl">Rewards</h2>
        <PickemsRewardsMinimumParticipantsNote rewardsNotice={rewardsNotice} />
        <div className="flex flex-col gap-4">
          {rewards.slice(0, 3).map((reward, index) => (
            <PickemRewardCard
              index={index}
              key={reward.label}
              reward={reward}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
